'use client';

import { useClient } from 'ui-hooks/useClient';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { usePathname, useRouter } from 'next/navigation';
import { buildCertificateUrl } from 'utils/url';
import { useCallback } from 'react';
import { useAuthState } from 'contexts/AuthProvider';
import { useRequestSign } from 'ui-hooks/useRequestSign';

export const useRequestCertificate = () => {
  const pathname = usePathname();
  const router = useRouter();
  const { isApp } = useClient();
  const { isLoaded, isLoggedIn } = useAuthState();
  const requestSign = useRequestSign();

  return useCallback(() => {
    if (!isLoaded) {
      return;
    }

    if (!isLoggedIn) {
      requestSign();
      return;
    }

    const link = buildCertificateUrl(pathname ?? '');

    if (isApp) {
      DirittoAppBridge.openSignView(link);
      return;
    }
    router.push(link);
  }, [isApp, isLoaded, isLoggedIn, requestSign, router, pathname]);
};
